export const DEFAULT_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = [
  'ar',
  'bn',
  'nl',
  'en',
  'fi',
  'fr',
  'de',
  'hi',
  'id',
  'it',
  'ja',
  'ko',
  'zh',
  'no',
  'pl',
  'pt',
  'pa',
  'ro',
  'ru',
  'so',
  'es',
  'sv',
  'tr',
  'uk',
  'ur',
  'cy',
];
